export const COMP_OFF_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const COMP_OFF_STATUS_LABELS = {
  [COMP_OFF_STATUS.PENDING]: 'Pending',
  [COMP_OFF_STATUS.APPROVED]: 'Approved',
  [COMP_OFF_STATUS.REJECTED]: 'Rejected',
  [COMP_OFF_STATUS.CANCELLED]: 'Cancelled',
};

export const COMP_OFF_STATUS_COLORS = {
  [COMP_OFF_STATUS.PENDING]: 'warning',
  [COMP_OFF_STATUS.APPROVED]: 'success',
  [COMP_OFF_STATUS.REJECTED]: 'error',
  [COMP_OFF_STATUS.CANCELLED]: 'default',
};

export const INITIAL_COMP_OFF_FORM_STATE = {
  workDate: null,
  hoursWorked: '',
  tasksCompleted: '',
  description: '',
  reviewers: [],
};
